import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestCustomfieldComponent } from './request-customfield.component';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';

@NgModule({
	declarations: [],
	imports: [RequestCustomfieldComponent],
	exports: [RequestCustomfieldComponent],
})
export class RequestCustomfieldModule {}
